const isActiveSubscriptionButtonsPredicate = (component) =>
  component.type === 'customButton' &&
  component.subtype === 'buy' &&
  component.enable &&
  component.value.buy &&
  component.value.buy.type === 'subscription';

export const isSubscriptionUsed = (block) =>
  block.components.some((component) => {
    const isBlockWithNestedComponents =
      component.components && component.components.length !== 0;
    if (isBlockWithNestedComponents) {
      return component.components.some((innerComponent) =>
        isActiveSubscriptionButtonsPredicate(innerComponent)
      );
    }
    return isActiveSubscriptionButtonsPredicate(component);
  });
